import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { CurrentDataService } from '../../services/current-data-service';

@Injectable({ providedIn: 'root' })
export class AvailableTransporterGuard implements CanActivate {
  constructor(private router: Router, public service: CurrentDataService) {}

  canActivate(): Observable<boolean> {
    return this.service.getCurrentTransporter().pipe(
      take(1),
      map(current => {
        if (current) {
          return true;
        } else {
          this.router.navigate(['/404']);
          return false;
        }
      })
    );
  }
}
